import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type DeliveryNotesByIdsAdminRequest,
  type DeliveryNotesByIdsAdminResponse,
} from './types.ts';
import { zodDeliveryNotesByIdsAdminRequestSchema } from './validations';

/**
 * Fetches delivery notes by IDs for admin users.
 *
 * @param request - Request payload containing the IDs to fetch.
 * @param options - Optional request options (e.g., abort signal).
 * @returns Delivery note assets for the requested IDs.
 *
 * @see https://app.dev.vestigas.com/redoc
 */
export const fetchDeliveryNotesByIdsAdmin = async (
  { ids }: DeliveryNotesByIdsAdminRequest,
  options?: KyRequestOptions,
): Promise<DeliveryNotesByIdsAdminResponse> => {
  try {
    return await vestigasApi
      .post(ENDPOINT.DELIVERY.GET_BY_IDS_ADMIN(), {
        json: { ids },
        validate: { body: zodDeliveryNotesByIdsAdminRequestSchema },
        ...options,
      })
      .json<DeliveryNotesByIdsAdminResponse>();
  } catch (error) {
    log.error({
      message: 'Error fetching Delivery Notes by IDs Admin',
      error,
    });

    throw error;
  }
};
